import React, { useState } from 'react'
import { CrossIcon, MHWhiteLogo } from '../../assets/Icons'
import Toast from '../../components/ui/Toast'
import { useNavigate } from "react-router-dom";
import Modal from "../../components/ui/Modal";
import brand from "../../assets/images/brandLogo.png"
import convera from "../../assets/images/convera_logo.png"
import { getMhReferenceId, getConveraClientSearchByCountry } from '../../services/navigate/getMhRefId';
import Select from "react-select";
import { encryptData } from '../../utils';

const countryOptions = [
    { country: "Australia", iso: "AUS" },
    { country: "Austria", iso: "AUT" },
    { country: "Canada", iso: "CAN" },
    // { country: "Czech Republic", iso: "CZE" },
    { country: "France", iso: "FRA" },
    { country: "Germany", iso: "DEU" },
    // { country: "Hong Kong", iso: "HKG" },
    // { country: "Italy", iso: "ITA" },
    { country: "Japan", iso: "JPN" },
    { country: "New Zealand", iso: "NZL" },
    { country: "Singapore", iso: "SGP" },
    { country: "Switzerland", iso: "CHE" },
    { country: "United Kingdom", iso: "GBR" },
    { country: "United States", iso: "USA" },
];

const Convera = () => {
    const [toastMessage, setToastMessage] = useState<any>();
    const [isModalOpen, setIsModalOpen] = useState<any>(false);
    const [generatedUDID, setGeneratedUDID] = useState<any>(null);
    const [selectedUniversity, setSelectedUniversity] = useState<{ value: string; label: string } | null>(null);
    const [selectedCountry, setSelectedCountry] = useState<{ value: string; label: string } | null>(null);
    const [universityOptions, setUniversityOptions] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const navigate = useNavigate();


    const invokeConveraPayment = async () => {
        const user = JSON.parse(localStorage.getItem("currentUser") || "{}");

          const countryCode =  "IND";
          const institution = selectedUniversity?.value;

        try {
            setLoading(true);
            const generatedUDIDResponse = await getMhReferenceId({
                name: user?.username || "",
                phone: user?.phoneNumber || "",
                email: user?.username || "",
                country: "IND",
                institution: selectedUniversity?.label
            });

            const generatedID = generatedUDIDResponse?.data?.mh_reference_id;
            setGeneratedUDID(generatedID)
            setLoading(false);
            sessionStorage.setItem("generatedUDID", generatedID);

     const DATA_INPUT = `
    <?xml version="1.0" encoding="UTF-8" standalone="yes"?>
    <paymentInformation>
      <clientReference>${generatedID}</clientReference>   
      <clientId>${institution}</clientId>
      <merchantId>51bc057e9f3b49ae9aa286299538b732</merchantId>
      <merchantSecret>15ce8410df0c449495e684834264c4c1</merchantSecret>
      <returnUrl>/convera</returnUrl>
      <buyerCanEdit>true</buyerCanEdit>
      <buyer>
        <country>${countryCode}</country>
      </buyer>
    </paymentInformation>`;

            sessionStorage.setItem("sellerInfoXML",encryptData( DATA_INPUT.trim()));
            navigate(`/convera/${generatedID}`);
        } catch (err) {
            console.error("Error generating MH Reference ID", err);
            setLoading(true);
            // alert("Something went wrong. Please try again.");
        }
    };

    const handleCountryChange = async (option:any) => {
        setSelectedCountry(option);
        setSelectedUniversity(null);
        setUniversityOptions([]);
        setLoading(true);
        try {
            const result = await getConveraClientSearchByCountry({ countryIso: option?.iso });
            if (result?.data && Array.isArray(result?.data)) {
                const universities = result?.data ?? [];

                const formattedUniversities = universities.map((uni:any) => ({
                    label: uni?.displayName!== "" ? uni?.displayName : uni?.name,
                    value: uni?.id ?? uni?.name,
                }));

                setUniversityOptions(formattedUniversities);
            } else {
                setUniversityOptions([]);
            }
        } catch (error) {
            console.error("Failed to fetch universities", error);
            setUniversityOptions([]);
        } finally {
            setLoading(false);
        }
    };



    const handleCloseToast = () => {
        setToastMessage(null);
    };

    return (
        <div className='w-full bg-custom-gradient flex flex-col'>
            {toastMessage && (
                <Toast
                    message={toastMessage?.message?.toUpperCase()}
                    type={toastMessage?.success === "true" ? "success" : "failure"}
                    onClose={handleCloseToast}
                />
            )}
            <div className="flex flex-col items-center bg-primary-1050 py-8">
                <div className="flex flex-col items-center justify-center w-full">
                    <div
                        onClick={() => {
                            navigate("/home")
                        }}
                        className="pb-[25px] flex cursor-pointer"
                    >
                        <MHWhiteLogo />
                    </div>
                    <div className="px-8 md:px-0 py-4 md:py-4 text-white text-md md:text-[20px] w-full flex flex-col gap-5 justify-center items-center">
                        <p>K2 (by moneyHOP) partners with Convera to offer a seamless international education payments experience on a single platform.</p>
                        <p>Our partnership with Convera brings you 0.5% lower rates than convera official website</p>
                    </div>
                </div>
            </div>



            <div className="p-5 md:p-8 py-2 flex flex-col items-center h-full min-h-[80vh]">
                <div className=" p-2 w-full md:flex items-center justify-end md:visible hidden">
                    <CrossIcon onClick={() => {
                        setIsModalOpen("cancelReasons")
                    }} className="cursor-pointer m-4" />
                </div>
                <div className='flex flex-col items-center gap-7 p-8 md:flex-row '>
                    <img src={brand} alt="Brand Logo" width={200} height={220} />
                    <span className='text-xl -mt-1'>x</span>
                    <img src={convera} alt="Brand Logo" width={140} height={140} />
                </div>

                <div className='bg-inherit p-5 md:p-20 w-full flex flex-col gap-10 border-none outline-none border-0 items-center h-full'>
                    <div className='flex flex-col gap-8'>
                        <div className='flex flex-col gap-4 self-stretch justify-center items-start'>
                            <p className="text-black font-inter text-sm font-medium leading-normal text-left">Select Country of Educational University</p>
                            <div className="min-w-[40%] w-full md:w-[420px]">
                                <Select<{ value: any; label: any }>
                                    placeholder="Select a country"
                                    options={countryOptions.map((c) => ({
                                        label: c.country,
                                        value: c.iso,
                                        iso: c.iso,
                                    }))}
                                    value={selectedCountry}
                                    onChange={handleCountryChange}
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            backgroundColor: "#fff",
                                            boxShadow: "0px 1px 2px 0px rgba(50, 50, 71, 0.08), 0px 0px 1px 0px rgba(50, 50, 71, 0.20)",
                                            paddingInline: "18px",
                                            height: "46px",
                                            alignSelf: "stretch",
                                            borderRadius: "6px",
                                            color: "#b5b5bd",
                                            fontFamily: "Inter",
                                            fontSize: "16px",
                                            fontWeight: 500,
                                            fontStyle: "normal",
                                            minHeight: "46px",
                                            borderColor: "#0f5bf1",
                                            borderWidth: "1px"
                                        }),
                                        // dropdownIndicator: () => ({ display: 'none' }),
                                        indicatorSeparator: () => ({ display: "none" }),
                                        valueContainer: (base) => ({
                                            ...base,
                                            padding: 0,
                                            margin: 0,
                                        }),
                                        input: (base) => ({
                                            ...base,
                                            margin: 0,
                                            padding: 0,
                                        }),
                                        placeholder: (base) => ({
                                            ...base,
                                            margin: 0,
                                            padding: 0,
                                        }),
                                        menu: (base) => ({
                                            ...base,
                                            zIndex: 9999,
                                            fontFamily: "Inter",
                                            fontSize: "14px",
                                        }),
                                        option: (base, { isFocused }) => ({
                                            ...base,
                                            backgroundColor: isFocused ? "#f0f0f0" : "#fff",
                                            color: "#425466",
                                            padding: "10px 18px",
                                            cursor: "pointer",
                                        }),
                                        singleValue: (base) => ({
                                            ...base,
                                            margin: 0,
                                            color: "#425466",
                                        }),
                                    }}
                                    components={{
                                        IndicatorSeparator: () => null,
                                    }}
                                />
                            </div>
                        </div>
                        <div className='flex flex-col gap-4 self-stretch justify-center items-start'>
                            <p className="text-black font-inter text-sm font-medium leading-normal">Select your University</p>
                            <div className="min-w-[40%] w-full md:w-[420px]">
                                <Select
                                    options={universityOptions}
                                    value={selectedUniversity}
                                    onChange={setSelectedUniversity}
                                    placeholder={loading ? "Loading Universities..." : "Select your University"}
                                    isDisabled={loading || !selectedCountry}
                                    styles={{
                                        control: (base, state) => ({
                                            ...base,
                                            backgroundColor: "#fff",
                                            boxShadow:
                                                "0px 1px 2px 0px rgba(50, 50, 71, 0.08), 0px 0px 1px 0px rgba(50, 50, 71, 0.20)",
                                            paddingInline: "18px",
                                            height: "46px",
                                            alignSelf: "stretch",
                                            borderRadius: "6px",
                                            color: "#b5b5bd",
                                            fontFamily: "Inter",
                                            fontSize: "16px",
                                            fontWeight: 500,
                                            fontStyle: "normal",
                                            minHeight: "46px",
                                            cursor: state.isDisabled ? "not-allowed" : "pointer",
                                            opacity: state.isDisabled ? 0.5 : 1,
                                            borderColor: "#0f5bf1",
                                            borderWidth: "1px"
                                        }),
                                        // dropdownIndicator: () => ({ display: 'none' }),
                                        indicatorSeparator: () => ({ display: "none" }),
                                        valueContainer: (base) => ({
                                            ...base,
                                            padding: 0,
                                            margin: 0,
                                        }),
                                        input: (base) => ({
                                            ...base,
                                            margin: 0,
                                            padding: 0,
                                        }),
                                        placeholder: (base) => ({
                                            ...base,
                                            margin: 0,
                                            padding: 0,
                                        }),
                                        menu: (base) => ({
                                            ...base,
                                            zIndex: 9999,
                                            fontFamily: "Inter",
                                            fontSize: "14px",
                                        }),
                                        option: (base, { isFocused }) => ({
                                            ...base,
                                            backgroundColor: isFocused ? "#f0f0f0" : "#fff",
                                            color: "#425466",
                                            padding: "10px 18px",
                                            cursor: "pointer",
                                        }),
                                        singleValue: (base) => ({
                                            ...base,
                                            margin: 0,
                                            color: "#425466",
                                        }),
                                    }}
                                    components={{
                                        IndicatorSeparator: () => null,
                                    }}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="w-full justify-center items-start flex">
                        <button onClick={() => invokeConveraPayment()} className={"font-semibold rounded-lg p-4 px-6 bg-primary-1050 w-full md:w-[220px] text-white hover:text-primary-1050 hover:border-primary-1050 hover:bg-white border-2 hover:ease-in hover:delay-150 hover:duration-150 " + (loading || !selectedUniversity || !selectedCountry ? "cursor-not-allowed opacity-10" : "cursor-pointer")}
                            disabled={!selectedUniversity || !selectedCountry || loading}
                            >
                            Click to proceed
                        </button>
                    </div>
                </div>
            </div>

            <Modal
                header="Cancel Transaction"
                headerClass={"text-white"}
                modalClass="!p-0 rounded lg:overflow-hidden overflow-y-scroll max-h-[90%] lg:max-h-full"
                visible={isModalOpen === "cancelReasons"}
                closeHandler={() => setIsModalOpen("")}
                closable={false}
            >
                <div className="flex flex-col items-center px-5 py-10 space-y-6">
                    <span className="font-ssp text-[18px] ">
                        Are you sure you want to cancel the transaction?
                    </span>
                    <div className="flex justify-center w-full space-x-5">
                        <button
                            onClick={() => navigate("/home")}
                            className="w-1/4 px-6 py-2 font-bold text-white transition-all rounded-full bg-primary hover:bg-primary-650 hover:scale-105 font-ssp"
                        >
                            Yes
                        </button>
                        <button
                            onClick={() => setIsModalOpen("")}
                            className="w-1/4 px-6 py-2 font-bold text-white transition-all rounded-full bg-primary hover:bg-primary-650 hover:scale-105 font-ssp"
                        >
                            No
                        </button>
                    </div>
                </div>
            </Modal>
        </div>
    )
}

export default Convera